import request from "@/service";

// 获取音频列表
export function getAudioList(data) {
  return request({
    url: `/resource/audio/info/page`,
    method: "get",
    params: data
  });
}

// 删除音频
export function deleteAudios(data) {
  return request({
    url: `/resource/audio/info/delete`,
    method: "delete",
    data
  });
}

// 新增音频
export function saveAudio(data) {
  return request({
    url: `/resource/audio/info/save`,
    method: "post",
    data
  });
}

// 获取音频详情
export function getAudioInfo(data) {
  return request({
    url: `/resource/audio/info/info/${data}`,
    method: "get"
  });
}

// 修改音频
export function editAudio(data) {
  return request({
    url: `/resource/audio/info/update`,
    method: "put",
    data
  });
}

// 音频上下线审核
export function setVideoOnlineAudit(data) {
  return request({
    url: `/resource/video/info/saveVideoAudit`,
    method: "put",
    data
  });
}

// 音频上下线
export function setAudioOnlineStatus(data) {
  return request({
    url: `/resource/audio/info/online`,
    method: "put",
    data
  });
}

// 音频分类
export function setAudioCategory(data) {
  return request({
    url: `/resource/audio/info/category`,
    method: "put",
    data
  });
}

// 音频共享记录
export function audioSharePage(data) {
  return request({
    url: `/resource/audio/info/sharePage`,
    method: "get",
    params: data
  });
}

// 恢复音频
export function recoveryAudio(data) {
  return request({
    url: `/resource/audio/info/recoveryAudio`,
    method: "put",
    data
  });
}

// 音频共享
export function shareAudio(data) {
  return request({
    url: `/resource/audio/info/shareAudio`,
    method: "put",
    data
  });
}

// 取消音频共享
export function cancelShareAudio(data) {
  return request({
    url: `/resource/audio/info/cancelShareAudio`,
    method: "put",
    data
  });
}

// 音频一键共享
export function shareAllAudio(data) {
  return request({
    url: `/resource/audio/info/shareAllAudio`,
    method: "put",
    data
  });
}

//音频统计-概况-jcc
export function audioBasic(params) {
  return request({
    url: `/resource/audio/info/statistic/basic`,
    method: "get",
    params
  });
}

// 音频统计-学习明细-jcc
export function audioLearn(params) {
  return request({
    url: `/resource/audio/info/statistic/learn`,
    method: "get",
    params
  });
}

/* 音频统计-学习明细-jcc */
export function exportAudioStatisticInfo(data) {
  return request({
    url: `/resource/audio/info/statistic/exportAudio`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}
